<template>
    <div class="row" :class="{'mt-4':itemIndex > 0}">
        <div class="col-12">
            <div class="row">
                <div class="col-2" :class="{'has-error': hasError(`other_entity_type.${itemIndex}`)}">
                    <label>{{ __('other_entity_role') }}{{
                            isRequiredDesignation('other_entity_type')
                        }}</label>
                    <select2
                        :disabled="disabled"
                        :settings="{ width: '100%' }"
                        :value="item.document_other_entity_type_id"
                        @change="emitInput('document_other_entity_type_id', $event)"
                        :options="otherEntityTypeOptions"
                    />
                    <InputErrors :errors="getErrors(`other_entity_type.${itemIndex}`)"/>
                </div>
                <div :class="{'has-error': hasError(`role_name.${itemIndex}`)}" class="col-4" v-show="item.document_other_entity_type_id == 10">
                    <InputWrapper
                        :disabled="disabled"
                        :errors="getErrors(`role_name.${itemIndex}`)"
                        :label="__('role_description')"
                        :required="isRequired('other_entity_role_name')"
                        :type="'text'"
                        :value="item.role_name"
                        classNames="form-control"
                        @input="emitInput('role_name', $event)"
                    />
                </div>
                <div :class="{'has-error': hasError(`participation.${itemIndex}`)}" class="col-4" v-show="item.document_other_entity_type_id == 3">
                    <InputWrapper
                        :disabled="disabled"
                        :errors="getErrors(`participation.${itemIndex}`)"
                        :label="__('participation_%')"
                        :required="isRequired('other_entity_participation')"
                        :value="item.participation | percentParticipation"
                        mask="percentagesBelow100"
                        classNames="form-control"
                        @input="emitInput('participation', $event)"
                    />
                </div>
                <div class="col-3">

                </div>
                <div class="col-md-auto table-icons" style="width: 45px; position: absolute;right: 10px">
                    <label class="m-b"> </label><br>
                    <a v-if="!disabled"
                       :data-original-title="__('delete')"
                       data-placement="top"
                       data-toggle="tooltip"
                       @click="removeRow">
                        <i class="fa fa-trash"></i>
                    </a>
                </div>
            </div>

        </div>

        <div class="col-md-4" :class="{'has-error': hasError(`other_entity_contractor_id.${itemIndex}`)}">
            <label>{{ __('company_name_or_first_name_and_second_name') }}{{
                    isRequiredDesignation('contractor')
                }}</label>
            <select2
                v-if="item.document_other_entity_type_id != 2"
                :disabled="disabled"
                :settings="{ width: '100%' }"
                :value="item.contractor_id"
                :options="contractorsOptions"
                @change="emitInput('contractor_id', $event)"
            />
            <input v-else :value="item.name" class="form-control" disabled type="text">
            <InputErrors :errors="getErrors(`other_entity_contractor_id.${itemIndex}`)"/>
        </div>

        <div class="col-md-2">
            <label>{{ __('country') }}</label>
            <input :value="item.country" class="form-control" disabled type="text">
        </div>

        <div class="col-md-2">
            <label>{{ __('identification_number_id') }}</label>
            <input :value="__(item.number_type)" class="form-control" disabled type="text">
        </div>

        <div :class="{'has-error': hasError('contractor_id_number')}" class="col">
            <label>{{ __('identification_number') }}{{ isRequiredDesignation('contractor') }}</label>

            <select2
                :disabled="disabled"
                v-if="item.document_other_entity_type_id == 2"
                :id="uniqueMySelect"
                :settings="{ width: '100%' }"
                :value="selectedIdNumber"
                :key="itemIndex"
                class="select-number-other-entity"
                :options="otherEntitiesIdNumbers"
                @input="contractorChangedByIdNumberOtherEntity"
            />
            <select2
                :disabled="disabled"
                v-else
                :id="uniqueMySelect"
                :settings="{ width: '100%' }"
                :value="selectedIdNumber"
                :key="itemIndex"
                :options="otherEntitiesIdNumbers"
                @input="contractorChangedByIdNumberOtherEntity"
            />
            <InputErrors :errors="getErrors('contractor_id_number')"/>
        </div>
        <div class="col-md-auto" v-if="type.type_name == 'invoicing_pl_VAT' || type.type_name == 'invoicing_pl_margin'">
            <div class="input-group m-l-xs m-r-xs m-b-xs m-t-sm"><label class=" disabled-label"><input type="checkbox"
                                                                                                       readonly="readonly"
                                                                                                       class="mt-3 protect-unsaved-changes disabled-checkbox&quot;"
                                                                                                       v-model="item.vies">
                VIES </label></div>
        </div>

        <div class="col-md-6">
            <div class="row m-b-sm">
                <div class="col-md-12 m-b-sm">
                    <label>{{ __('full_address') }}</label>
                    <input :value="item.address" class="form-control" disabled type="text">
                </div>
                <div class="col-md-12 m-b-sm">
                    <input :value="item.address_2" class="form-control" disabled type="text">
                </div>
                <div class="col-md-6 m-b-sm">
                    <label>{{ __('zip') }}</label>
                    <input :value="item.zip" class="form-control" disabled type="text">
                </div>
                <div class="col-md-6 m-b-sm">
                    <label>{{ __('city') }}</label>
                    <input :value="item.city" class="form-control" disabled type="text">
                </div>
            </div>
        </div>
        <div class="col-md-6">
            <div class="form-group">
                <label>{{ __('remarks') }}</label>
                <textarea
                    :value="item.remarks"
                    class="form-control"
                    disabled
                    style="height:126px;"
                    type="text"></textarea>
            </div>
        </div>

    </div>
</template>

<script>
import inputEmit from "../../mixins/inputEmit";
import hasErrors from "../../mixins/hasErrors";
import hasPermissions from "../../mixins/hasPermissions";
import hasRequiredFields from "../../mixins/hasRequiredFields";
import InputErrors from "../form/InputErrors";
import InputWrapper from "../form/InputWrapper";
import hasTooltips from "../../mixins/hasTooltips";

export default {
    name: "OtherEntityRow",
    components: {InputErrors, InputWrapper},
    mixins: [inputEmit, hasErrors, hasRequiredFields, hasTooltips],
    props: {
        item: {
            type: Object,
            default: {},
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        type: {
            type: Object,
            required: true,
        },
        otherEntitiesTypes:{
            type: Array,
            default: () => [],
        },
        uniqueId:{
            type: String,
            default: '',
        },
        itemIndex: {
            type: Number,
            required: true,
        },
        contractors: {
            type: Array,
            default: () => [],
        },
        originalCompany: {
            type: Object,
            default: () => {},
        },
    },
    methods: {
        contractorChangedOtherEntity() {

        },
        contractorChangedByIdNumberOtherEntity(value) {
            if (typeof value === 'string') {
                if(this.item.document_other_entity_type_id != 2){
                    let idParts = value.split('-');
                    let contractorId = parseInt(idParts[0]);
                    let numberId = parseInt(idParts[1]);

                    contractorId = contractorId == 0 ? 0 : contractorId;
                    this.emitInput('contractor_id', contractorId);
                    this.emitInput('contractor_id_number_selected', numberId)
                    if (this.selectedContractor.id == contractorId) {
                        // this.handleContractorVies(numberId)
                        let selectId = this.uniqueMySelect
                        $('#'+selectId).val(this.selectedIdNumber); // Select the option with a value of '1'
                        $('#'+selectId).parent().find('.select2-selection__rendered').text(this.selectedIdText)
                    }
                }
                else{
                    //hack for force select option
                    let selectId = this.uniqueMySelect
                    $('#'+selectId).val(this.selectedIdNumber); // Select the option with a value of '1'
                    $('#'+selectId).parent().find('.select2-selection__rendered').text(this.selectedIdText)
                    this.emitInput('contractor_id_number_selected', value)
                }

            }
        },
        removeRow() {
            this.$emit('removeOtherEntity');
            this.clearTooltips();
        },
        calculateSelectedIdNumber(){


        }
    },
    computed:{
        uniqueMySelect(){
            return 'mySelect2-'+ this.uniqueId
        },
        selectedIdNumber() {
            if (this.item.contractor_id > 0 && this.item.document_other_entity_type_id != 2){
                return `${this.item.contractor_id}-${this.item.contractor_id_number_selected}`;
            }
            else if(this.item.document_other_entity_type_id == 2){
                return this.item.contractor_id_number_selected;
            }
            else {
                return '0-0';
            }
        },
        selectedIdText() {

            let option = this.otherEntitiesIdNumbers.find((item) =>
                item.id === this.selectedIdNumber
            );
            return option ? option.text : ''
        },
        otherEntityTypeOptions(){
            var options = this.otherEntitiesTypes.map((option) => ({text: this.__(option.name), id: option.id}));
            options.unshift({text: '---', id: 0});
            return options;
        },
        contractorsOptions() {
            let contractors = this.contractors.filter(function (contractor){
                return contractor.is_complete == 1;
            })
            var options = contractors.map((option) => ({text: option.name, id: option.id}));
            options.unshift({text: '---', id: 0});

            return options;
        },
        selectedContractor() {
            return this.contractors.find(c => c.id == this.item.contractor_id) || {};
        },
        otherEntitiesIdNumbers() {
            if(this.item.document_other_entity_type_id != 2){
                let options = [];
                let contractors = this.item.contractor_id > 0 ? [this.selectedContractor] : this.contractors;
                for (let contractor of contractors) {
                    if(contractor.is_complete == true){
                        if (contractor.id_number.length) {
                            options.push({text: contractor.id_number, id: contractor.id + '-1'});
                        }
                        if (contractor.second_id_number.length) {
                            options.push({text: contractor.second_id_number, id: contractor.id + '-2'});
                        }
                    }

                }

                options.sort((a, b) => a.text < b.text ? -1 : 1);
                options.unshift({text: '---', id: '0-0'});

                return options;
            }
            else{
                let options = [];
                if(this.originalCompany && this.originalCompany.id_number.id != 18){
                    options.push({text: this.originalCompany.identification_number, id: 1});
                }
                if(this.originalCompany && this.originalCompany.id_number_secondary.id != 18){
                    options.push({text: this.originalCompany.secondary_identification_number, id: 2});
                }
                return options;
            }

        }
    }
}
</script>

<style scoped>

</style>
